export var MaritalStatus;
(function (MaritalStatus) {
    MaritalStatus["Unmarried"] = "Unmarried";
    MaritalStatus["Married"] = "Married";
    MaritalStatus["Divorced"] = "Divorced";
})(MaritalStatus || (MaritalStatus = {}));
